import { render, staticRenderFns } from "./pelunasan-admin.vue?vue&type=template&id=282afd60&scoped=true&"
import script from "./pelunasan-admin.vue?vue&type=script&lang=js&"
export * from "./pelunasan-admin.vue?vue&type=script&lang=js&"
import style0 from "./pelunasan-admin.vue?vue&type=style&index=0&id=282afd60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282afd60",
  null
  
)

export default component.exports